import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 16.5H8",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 12.5H5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMail;
